import { format, subHours } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import localconfig from '../../config';
import useAnnouncementQuery from '../../hooks/useAnnouncementQuery';
import { ContentCard } from '../../layout/ContentCard';
import AnnouncementForm from './AnnouncementForm';

const AnnouncementFormPage = () => {
  const { t } = useTranslation();
  let { id } = useParams();
  const announcementId = Number(id);
  const isUpdate = !isNaN(announcementId);

  const announcementQuery = useAnnouncementQuery(announcementId);

  const endDate = announcementQuery.data?.end
    ? format(
        // @ts-ignore
        subHours(new Date(announcementQuery.data?.end ?? null), 11),
        'yyyy-MM-dd',
      )
    : null;

  if (announcementQuery.isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <ContentCard
      isLoading={announcementQuery.isFetching}
      header={isUpdate ? t('forms:header.edit') : t('forms:header.create')}
      maxWidth={{ base: 'full', xl: '85%' }}
    >
      <AnnouncementForm
        isDataLoaded={!!announcementQuery.data}
        method={id ? 'put' : 'post'}
        url={`${localconfig.apiBaseUrl}/op/v1/announcement${id ? `/${id}` : ''}`}
        defaultValues={{
          ...announcementQuery.data,
          end: endDate,
          country: announcementQuery.data?.country ?? [],
        }}
        record={announcementQuery.data}
        isUpdate={isUpdate}
      />
    </ContentCard>
  );
};

export default AnnouncementFormPage;
